export default {
  requirements: {

    "step1": [
      // step 1 

      { name: 'orSection', status: { disabled: true, hide: true } },
      { name: 'saveBtn', status: { disabled: true, hide: true } },
      { name: 'nextBtn', status: { disabled: false, hide: false } },
      { name: 'prevBtn', status: { disabled: true, hide: true } },
      { name: 'inforceBtn', status: { disabled: true, hide: true } },
      { name: 'rejectBtn', status: { disabled: true, hide: true } },
      { name: 'policyInfomation', status: { disabled: false, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: true } },

      { name: 'productName', status: { disabled: false, hide: false } },
      { name: 'policyNumber', status: { disabled: false, hide: false } },
      { name: 'policyReference', status: { disabled: false, hide: false } },
      { name: 'applicationDate', status: { disabled: false, hide: false } },
      { name: 'applicationReceiveDate', status: { disabled: false, hide: false } },
      { name: 'policyCurrency', status: { disabled: false, hide: false } },
      { name: 'policyType', status: { disabled: false, hide: false } },
      { name: 'modalPremium', status: { disabled: false, hide: false } },
      { name: 'premiumPaid', status: { disabled: false, hide: false } },
      { name: 'premiumType', status: { disabled: false, hide: false } },
      { name: 'actuallyPaid', status: { disabled: false, hide: false } },
      { name: 'paymentMethod', status: { disabled: false, hide: false } },
      { name: 'companyBank', status: { disabled: false, hide: false } },
      { name: 'paymentReference', status: { disabled: false, hide: false } },
      { name: 'paymentAmount', status: { disabled: false, hide: false } },
      { name: 'paymentDate', status: { disabled: false, hide: false } },
      { name: 'originalAgent', status: { disabled: false, hide: false } },
      { name: 'currentAgent', status: { disabled: false, hide: false } },
      { name: 'policyAgent', status: { disabled: false, hide: false } },
      { name: 'ownerCustomer', status: { disabled: false, hide: false } },
      { name: 'policyFee', status: { disabled: false, hide: false } },
      { name: 'insuredCustomer', status: { disabled: false, hide: false } },
      { name: 'agentCommissionRate', status: { disabled: false, hide: false } },
      { name: 'agentCommissionPaid', status: { disabled: false, hide: false } },
      { name: 'newBusinessOrRenewal', status: { disabled: false, hide: false } },
      { name: 'levyOrMIB', status: { disabled: false, hide: false } },
      { name: 'specialLevy', status: { disabled: false, hide: false } },
      { name: 'premiumPaid', status: { disabled: false, hide: false } },
      { name: 'insurerRebate', status: { disabled: false, hide: false } },
      { name: 'chequeToInsurer', status: { disabled: false, hide: false } },
      { name: 'chequeToInsurerNumber', status: { disabled: false, hide: false } },
      { name: 'chequeIssueDate', status: { disabled: false, hide: false } },
      { name: 'remarks', status: { disabled: false, hide: false } },
      { name: 'docs', status: { disabled: false, hide: false } },
      { name: 'sentOutDate', status: { disabled: false, hide: true } },
      { name: 'sentOutMedium', status: { disabled: false, hide: true } },
      { name: 'sentOutReference', status: { disabled: false, hide: true } },
      // { name: 'courierNo', status: { disabled: false, hide: true } },
      { name: 'effectiveDate', status: { disabled: false, hide: true } },
      { name: 'expiryDate', status: { disabled: false, hide: true } },
      { name: 'issueDate', status: { disabled: false, hide: true } },
      { name: 'companyReceiveDate', status: { disabled: false, hide: true } },
      { name: 'agentReceiveDate', status: { disabled: false, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: false, hide: true } },
    ],

    "step2": [
      // step 2 
      { name: 'orSection', status: { disabled: true, hide: true } },
      { name: 'saveBtn', status: { disabled: true, hide: true } },
      { name: 'nextBtn', status: { disabled: false, hide: false } },
      { name: 'prevBtn', status: { disabled: true, hide: true } },
      { name: 'inforceBtn', status: { disabled: true, hide: true } },
      { name: 'rejectBtn', status: { disabled: true, hide: true } },
      { name: 'policyInfomation', status: { disabled: true, hide: false } },

      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceiveDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'policyType', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'actuallyPaid', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'paymentAmount', status: { disabled: true, hide: false } },
      { name: 'paymentDate', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: true, hide: false } },
      { name: 'ownerCustomer', status: { disabled: true, hide: false } },
      { name: 'policyFee', status: { disabled: true, hide: false } },
      { name: 'insuredCustomer', status: { disabled: true, hide: false } },
      { name: 'agentCommissionRate', status: { disabled: true, hide: false } },
      { name: 'agentCommissionPaid', status: { disabled: true, hide: false } },
      { name: 'newBusinessOrRenewal', status: { disabled: true, hide: false } },
      { name: 'levyOrMIB', status: { disabled: true, hide: false } },
      { name: 'specialLevy', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'insurerRebate', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurer', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurerNumber', status: { disabled: true, hide: false } },
      { name: 'chequeIssueDate', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: true } },
      { name: 'sentOutMedium', status: { disabled: true, hide: true } },
      { name: 'sentOutReference', status: { disabled: true, hide: true } },
      // { name: 'courierNo', status: { disabled: false, hide: true } },
      { name: 'effectiveDate', status: { disabled: true, hide: true } },
      { name: 'expiryDate', status: { disabled: true, hide: true } },
      { name: 'issueDate', status: { disabled: true, hide: true } },
      { name: 'companyReceiveDate', status: { disabled: true, hide: true } },
      { name: 'agentReceiveDate', status: { disabled: true, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: true, hide: true } },
    ],
    // step 3 sent out

    "step3": [
      { name: 'orSection', status: { disabled: true, hide: true } },
      { name: 'saveBtn', status: { disabled: true, hide: true } },
      { name: 'nextBtn', status: { disabled: false, hide: false } },
      { name: 'prevBtn', status: { disabled: false, hide: false } },
      { name: 'inforceBtn', status: { disabled: true, hide: true } },
      { name: 'rejectBtn', status: { disabled: true, hide: true } },
      { name: 'policyInfomation', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceiveDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'policyType', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'actuallyPaid', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'paymentAmount', status: { disabled: true, hide: false } },
      { name: 'paymentDate', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: true, hide: false } },
      { name: 'ownerCustomer', status: { disabled: true, hide: false } },
      { name: 'policyFee', status: { disabled: true, hide: false } },
      { name: 'insuredCustomer', status: { disabled: true, hide: false } },
      { name: 'agentCommissionRate', status: { disabled: true, hide: false } },
      { name: 'agentCommissionPaid', status: { disabled: true, hide: false } },
      { name: 'newBusinessOrRenewal', status: { disabled: true, hide: false } },
      { name: 'levyOrMIB', status: { disabled: true, hide: false } },
      { name: 'specialLevy', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'insurerRebate', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurer', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurerNumber', status: { disabled: true, hide: false } },
      { name: 'chequeIssueDate', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: false, hide: false } },
      { name: 'sentOutMedium', status: { disabled: false, hide: false } },
      { name: 'sentOutReference', status: { disabled: false, hide: false } },
      // { name: 'courierNo', status: { disabled: false, hide: true } },
      { name: 'effectiveDate', status: { disabled: true, hide: true } },
      { name: 'expiryDate', status: { disabled: true, hide: true } },
      { name: 'issueDate', status: { disabled: true, hide: true } },
      { name: 'companyReceiveDate', status: { disabled: true, hide: true } },
      { name: 'agentReceiveDate', status: { disabled: true, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: true, hide: true } },
    ],

    // step 4 
    "step4": [
      { name: 'orSection', status: { disabled: false, hide: false } },
      { name: 'saveBtn', status: { disabled: false, hide: false } },
      { name: 'nextBtn', status: { disabled: true, hide: true } },
      { name: 'prevBtn', status: { disabled: false, hide: false } },
      { name: 'inforceBtn', status: { disabled: false, hide: false } },
      { name: 'rejectBtn', status: { disabled: false, hide: false } },
      { name: 'policyInfomation', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceiveDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'policyType', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'actuallyPaid', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'paymentAmount', status: { disabled: true, hide: false } },
      { name: 'paymentDate', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: true, hide: false } },
      { name: 'ownerCustomer', status: { disabled: true, hide: false } },
      { name: 'policyFee', status: { disabled: true, hide: false } },
      { name: 'insuredCustomer', status: { disabled: true, hide: false } },
      { name: 'agentCommissionRate', status: { disabled: true, hide: false } },
      { name: 'agentCommissionPaid', status: { disabled: true, hide: false } },
      { name: 'newBusinessOrRenewal', status: { disabled: true, hide: false } },
      { name: 'levyOrMIB', status: { disabled: true, hide: false } },
      { name: 'specialLevy', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'insurerRebate', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurer', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurerNumber', status: { disabled: true, hide: false } },
      { name: 'chequeIssueDate', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: false } },
      { name: 'sentOutMedium', status: { disabled: true, hide: false } },
      { name: 'sentOutReference', status: { disabled: true, hide: false } },
      // { name: 'courierNo', status: { disabled: false, hide: true } },
      { name: 'effectiveDate', status: { disabled: true, hide: true } },
      { name: 'expiryDate', status: { disabled: true, hide: true } },
      { name: 'issueDate', status: { disabled: true, hide: true } },
      { name: 'companyReceiveDate', status: { disabled: true, hide: true } },
      { name: 'agentReceiveDate', status: { disabled: true, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: true, hide: true } },
    ],
    // step 5 

    "step5": [
      { name: 'orSection', status: { disabled: true, hide: true } },
      { name: 'saveBtn', status: { disabled: true, hide: true } },
      { name: 'nextBtn', status: { disabled: true, hide: true } },
      { name: 'prevBtn', status: { disabled: false, hide: false } },
      { name: 'rejectBtn', status: { disabled: false, hide: false } },
      { name: 'inforceBtn', status: { disabled: true, hide: true } },
      { name: 'policyInfomation', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceiveDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'policyType', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'actuallyPaid', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'paymentAmount', status: { disabled: true, hide: false } },
      { name: 'paymentDate', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: true, hide: false } },
      { name: 'ownerCustomer', status: { disabled: true, hide: false } },
      { name: 'policyFee', status: { disabled: true, hide: false } },
      { name: 'insuredCustomer', status: { disabled: true, hide: false } },
      { name: 'agentCommissionRate', status: { disabled: true, hide: false } },
      { name: 'agentCommissionPaid', status: { disabled: true, hide: false } },
      { name: 'newBusinessOrRenewal', status: { disabled: true, hide: false } },
      { name: 'levyOrMIB', status: { disabled: true, hide: false } },
      { name: 'specialLevy', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'insurerRebate', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurer', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurerNumber', status: { disabled: true, hide: false } },
      { name: 'chequeIssueDate', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: false } },
      { name: 'sentOutMedium', status: { disabled: true, hide: false } },
      { name: 'sentOutReference', status: { disabled: true, hide: false } },
      // { name: 'courierNo', status: { disabled: false, hide: true } },
      { name: 'effectiveDate', status: { disabled: true, hide: true } },
      { name: 'expiryDate', status: { disabled: true, hide: true } },
      { name: 'issueDate', status: { disabled: true, hide: true } },
      { name: 'companyReceiveDate', status: { disabled: true, hide: true } },
      { name: 'agentReceiveDate', status: { disabled: true, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: true, hide: true } },
    ],
    // step 6 

    "step6": [
      { name: 'orSection', status: { disabled: true, hide: true } },
      { name: 'saveBtn', status: { disabled: true, hide: true } },
      { name: 'nextBtn', status: { disabled: true, hide: true } },
      { name: 'prevBtn', status: { disabled: false, hide: false } },
      { name: 'rejectBtn', status: { disabled: true, hide: true } },
      { name: 'inforceBtn', status: { disabled: false, hide: false } },
      { name: 'policyInfomation', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceiveDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'policyType', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'actuallyPaid', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'paymentAmount', status: { disabled: true, hide: false } },
      { name: 'paymentDate', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: true, hide: false } },
      { name: 'ownerCustomer', status: { disabled: true, hide: false } },
      { name: 'policyFee', status: { disabled: true, hide: false } },
      { name: 'insuredCustomer', status: { disabled: true, hide: false } },
      { name: 'agentCommissionRate', status: { disabled: true, hide: false } },
      { name: 'agentCommissionPaid', status: { disabled: true, hide: false } },
      { name: 'newBusinessOrRenewal', status: { disabled: true, hide: false } },
      { name: 'levyOrMIB', status: { disabled: true, hide: false } },
      { name: 'specialLevy', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'insurerRebate', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurer', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurerNumber', status: { disabled: true, hide: false } },
      { name: 'chequeIssueDate', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: false } },
      { name: 'sentOutMedium', status: { disabled: true, hide: false } },
      { name: 'sentOutReference', status: { disabled: true, hide: false } },
      // { name: 'courierNo', status: { disabled: false, hide: true } },
      { name: 'effectiveDate', status: { disabled: false, hide: false } },
      { name: 'expiryDate', status: { disabled: false, hide: false } },
      { name: 'issueDate', status: { disabled: false, hide: false } },
      { name: 'companyReceiveDate', status: { disabled: true, hide: true } },
      { name: 'agentReceiveDate', status: { disabled: true, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: true, hide: true } },

    ],
    // step 7 

    "step7": [
      { name: 'orSection', status: { disabled: true, hide: true } },
      { name: 'saveBtn', status: { disabled: true, hide: true } },
      { name: 'nextBtn', status: { disabled: false, hide: false } },
      { name: 'prevBtn', status: { disabled: true, hide: true } },
      { name: 'rejectBtn', status: { disabled: true, hide: true } },
      { name: 'inforceBtn', status: { disabled: true, hide: true } },
      { name: 'policyInfomation', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceiveDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'policyType', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'actuallyPaid', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'paymentAmount', status: { disabled: true, hide: false } },
      { name: 'paymentDate', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: false, hide: false } },
      { name: 'ownerCustomer', status: { disabled: true, hide: false } },
      { name: 'policyFee', status: { disabled: true, hide: false } },
      { name: 'insuredCustomer', status: { disabled: true, hide: false } },
      { name: 'agentCommissionRate', status: { disabled: true, hide: false } },
      { name: 'agentCommissionPaid', status: { disabled: true, hide: false } },
      { name: 'newBusinessOrRenewal', status: { disabled: true, hide: false } },
      { name: 'levyOrMIB', status: { disabled: true, hide: false } },
      { name: 'specialLevy', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'insurerRebate', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurer', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurerNumber', status: { disabled: true, hide: false } },
      { name: 'chequeIssueDate', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: false } },
      { name: 'sentOutMedium', status: { disabled: true, hide: false } },
      { name: 'sentOutReference', status: { disabled: true, hide: false } },
      // { name: 'courierNo', status: { disabled: false, hide: true } },
      { name: 'effectiveDate', status: { disabled: true, hide: false } },
      { name: 'expiryDate', status: { disabled: true, hide: false } },
      { name: 'issueDate', status: { disabled: true, hide: false } },
      { name: 'companyReceiveDate', status: { disabled: false, hide: false } },
      { name: 'agentReceiveDate', status: { disabled: true, hide: true } },
      { name: 'customerReceiveDate', status: { disabled: true, hide: true } },
    ],
    // step 8

    "step8": [
      { name: 'orSection', status: { disabled: true, hide: true } },
      { name: 'saveBtn', status: { disabled: true, hide: true } },
      { name: 'nextBtn', status: { disabled: false, hide: false } },
      { name: 'prevBtn', status: { disabled: false, hide: false } },
      { name: 'rejectBtn', status: { disabled: true, hide: true } },
      { name: 'inforceBtn', status: { disabled: true, hide: true } },
      { name: 'policyInfomation', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceiveDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'policyType', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'actuallyPaid', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'paymentAmount', status: { disabled: true, hide: false } },
      { name: 'paymentDate', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: false, hide: false } },
      { name: 'ownerCustomer', status: { disabled: true, hide: false } },
      { name: 'policyFee', status: { disabled: true, hide: false } },
      { name: 'insuredCustomer', status: { disabled: true, hide: false } },
      { name: 'agentCommissionRate', status: { disabled: true, hide: false } },
      { name: 'agentCommissionPaid', status: { disabled: true, hide: false } },
      { name: 'newBusinessOrRenewal', status: { disabled: true, hide: false } },
      { name: 'levyOrMIB', status: { disabled: true, hide: false } },
      { name: 'specialLevy', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'insurerRebate', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurer', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurerNumber', status: { disabled: true, hide: false } },
      { name: 'chequeIssueDate', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: false } },
      { name: 'sentOutMedium', status: { disabled: true, hide: false } },
      { name: 'sentOutReference', status: { disabled: true, hide: false } },
      // { name: 'courierNo', status: { disabled: false, hide: true } },
      { name: 'effectiveDate', status: { disabled: true, hide: false } },
      { name: 'expiryDate', status: { disabled: true, hide: false } },
      { name: 'issueDate', status: { disabled: true, hide: false } },
      { name: 'companyReceiveDate', status: { disabled: true, hide: false } },
      { name: 'agentReceiveDate', status: { disabled: false, hide: false } },
      { name: 'customerReceiveDate', status: { disabled: true, hide: true } },
    ],
    // step 9

    "step9": [
      { name: 'orSection', status: { disabled: true, hide: true } },
      { name: 'saveBtn', status: { disabled: true, hide: true } },
      { name: 'nextBtn', status: { disabled: false, hide: false } },
      { name: 'prevBtn', status: { disabled: false, hide: false } },
      { name: 'rejectBtn', status: { disabled: true, hide: true } },
      { name: 'inforceBtn', status: { disabled: true, hide: true } },
      { name: 'policyInfomation', status: { disabled: true, hide: false } },
      { name: 'deleteBtn', status: { disabled: false, hide: false } },
      { name: 'productName', status: { disabled: true, hide: false } },
      { name: 'policyNumber', status: { disabled: true, hide: false } },
      { name: 'policyReference', status: { disabled: true, hide: false } },
      { name: 'applicationDate', status: { disabled: true, hide: false } },
      { name: 'applicationReceiveDate', status: { disabled: true, hide: false } },
      { name: 'policyCurrency', status: { disabled: true, hide: false } },
      { name: 'policyType', status: { disabled: true, hide: false } },
      { name: 'modalPremium', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'premiumType', status: { disabled: true, hide: false } },
      { name: 'actuallyPaid', status: { disabled: true, hide: false } },
      { name: 'paymentMethod', status: { disabled: true, hide: false } },
      { name: 'companyBank', status: { disabled: true, hide: false } },
      { name: 'paymentReference', status: { disabled: true, hide: false } },
      { name: 'paymentAmount', status: { disabled: true, hide: false } },
      { name: 'paymentDate', status: { disabled: true, hide: false } },
      { name: 'originalAgent', status: { disabled: true, hide: false } },
      { name: 'currentAgent', status: { disabled: true, hide: false } },
      { name: 'policyAgent', status: { disabled: false, hide: false } },
      { name: 'ownerCustomer', status: { disabled: true, hide: false } },
      { name: 'policyFee', status: { disabled: true, hide: false } },
      { name: 'insuredCustomer', status: { disabled: true, hide: false } },
      { name: 'agentCommissionRate', status: { disabled: true, hide: false } },
      { name: 'agentCommissionPaid', status: { disabled: true, hide: false } },
      { name: 'newBusinessOrRenewal', status: { disabled: true, hide: false } },
      { name: 'levyOrMIB', status: { disabled: true, hide: false } },
      { name: 'specialLevy', status: { disabled: true, hide: false } },
      { name: 'premiumPaid', status: { disabled: true, hide: false } },
      { name: 'insurerRebate', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurer', status: { disabled: true, hide: false } },
      { name: 'chequeToInsurerNumber', status: { disabled: true, hide: false } },
      { name: 'chequeIssueDate', status: { disabled: true, hide: false } },
      { name: 'remarks', status: { disabled: true, hide: false } },
      { name: 'docs', status: { disabled: true, hide: false } },
      { name: 'sentOutDate', status: { disabled: true, hide: false } },
      { name: 'sentOutMedium', status: { disabled: true, hide: false } },
      { name: 'sentOutReference', status: { disabled: true, hide: false } },
      // { name: 'courierNo', status: { disabled: false, hide: true } },
      { name: 'effectiveDate', status: { disabled: true, hide: false } },
      { name: 'expiryDate', status: { disabled: true, hide: false } },
      { name: 'issueDate', status: { disabled: true, hide: false } },
      { name: 'companyReceiveDate', status: { disabled: true, hide: false } },
      { name: 'agentReceiveDate', status: { disabled: true, hide: false } },
      { name: 'customerReceiveDate', status: { disabled: false, hide: false } },
    ]

  }
}



// WEBPACK FOOTER //
// ./src/Osm/GIPolicy/assets/_workflowStepRequirement.js